module.exports = __webpack_public_path__ + "static/media/tip_cat_tick.cb74cb11.png";